



import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { ECharts, EChartsOption, init } from 'echarts';
import option from './options';
/**
 * @author guan
 * @description 共用图表组件 new Echarts 构建图表
 */
@Component({})
export default class Echarts extends Vue {
    /** 传入的option */
    @Prop({ default: () => option })
    private propoption!: EChartsOption;
    /** 传入的容器高度 */
    @Prop({ default: () => '350px' })
    private defaultHeight!: string;
    /** 图表实例 */
    private chart!: ECharts;

    /**
     * @author guan
     * @description 监听option,option变化时更新图表
     * @return void
     * @param val 新配置
     */
    @Watch('propoption', { deep: true })
    onPersonChanged1(val: EChartsOption): void {
        if (this.chart) {
            this.chart.setOption(val);
        }
    }
    /**
     * @author guan
     * @description 初始化图表
     * @return void
     */
    mounted(): void {
        /** 初始化 */
        this.chart = init(this.$el as HTMLDivElement, 'macarons');
        window.onresize = () => {
            this.chart.resize();
        };
        setTimeout(() => {
            this.chart.setOption(this.propoption);
            this.chart.resize();
        }, 1000);
    }
}
